module.exports = __webpack_public_path__ + "static/media/logo_giztix.3ab36ac6.svg";